import { css } from '@emotion/react';

import theme from '../../theme';

export const globalStyles = css`
    /* DatePicker styles */
    .rdp {
        --rdp-cell-size: 30px;
        --rdp-accent-color: ${theme.color.green1};
        --rdp-background-color: ${theme.color.white};
        --rdp-accent-color-dark: #3003e1;
        --rdp-background-color-dark: #180270;
        --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */
        --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */

        margin: 1em;
        font-size: 14px;
    }

    /* Hide elements for devices that are not screen readers */
    .rdp-vhidden {
        box-sizing: border-box;
        padding: 0;
        margin: 0;
        background: transparent;
        border: 0;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        position: absolute !important;
        top: 0;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        overflow: hidden !important;
        clip: rect(1px, 1px, 1px, 1px) !important;
        border: 0 !important;
    }

    /* Buttons */
    .rdp-button_reset {
        appearance: none;
        position: relative;
        margin: 0;
        padding: 0;
        cursor: default;
        color: inherit;
        background: none;
        font: inherit;

        -moz-appearance: none;
        -webkit-appearance: none;
    }

    .rdp-button_reset:focus-visible {
        /* Make sure to reset outline only when :focus-visible is supported */
        outline: none;
    }

    .rdp-button {
        border: 2px solid transparent;
    }

    .rdp-button[disabled]:not(.rdp-day_selected) {
        opacity: 0.25;
    }

    .rdp-button:not([disabled]) {
        cursor: pointer;
    }

    .rdp-button:focus-visible:not([disabled]) {
        color: inherit;
        background-color: var(--rdp-background-color);
        border: var(--rdp-outline);
    }

    .rdp-months {
        display: flex;
    }

    .rdp-month {
        margin: 0;
    }

    .rdp-month:first-of-type {
        margin-left: 0;
    }

    .rdp-month:last-child {
        margin-right: 0;
    }

    .rdp-table {
        margin: 0;
        border-collapse: collapse;
    }

    .rdp-with_weeknumber .rdp-table {
        max-width: calc(var(--rdp-cell-size) * 8);
        border-collapse: collapse;
    }

    .rdp-caption {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        text-align: left;
    }

    .rdp-multiple_months .rdp-caption {
        position: relative;
        display: block;
        text-align: center;
    }

    .rdp-caption_dropdowns {
        position: relative;
        display: inline-flex;
    }

    .rdp-caption_label {
        position: relative;
        z-index: 1;
        margin: 0;
        display: inline-flex;
        align-items: center;
        padding: 0 0.5em;
        white-space: nowrap;
        color: currentColor;
        border: 0;
        font-family: inherit;
        font-weight: ${theme.typography.fontWeight.medium};
        font-size: 1.15em;
    }

    .rdp-nav {
        white-space: nowrap;
        padding: 0 0.5em;

        svg {
            display: none;
        }
    }

    .rdp-multiple_months .rdp-caption_start .rdp-nav {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }

    .rdp-multiple_months .rdp-caption_end .rdp-nav {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
    }

    .rdp-nav_button {
        display: inline-block;
        margin-top: 2px;
        width: 1.5em;
        height: 1.5em;
        background-position: center;
        background-size: 50%;
        background-repeat: no-repeat;
        cursor: pointer;

        :hover {
            opacity: 0.8;
        }
    }

    .rdp-nav_button_previous {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');
    }

    .rdp-nav_button_next {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');
    }

    /* ---------- */
    /* Dropdowns  */
    /* ---------- */

    .rdp-dropdown_year,
    .rdp-dropdown_month {
        position: relative;
        display: inline-flex;
        align-items: center;
    }

    .rdp-dropdown {
        appearance: none;
        position: absolute;
        z-index: 2;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        margin: 0;
        padding: 0;
        cursor: inherit;
        opacity: 0;
        border: none;
        background-color: transparent;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
    }

    .rdp-dropdown[disabled] {
        opacity: unset;
        color: unset;
    }

    .rdp-dropdown:focus-visible:not([disabled]) + .rdp-caption_label {
        background-color: var(--rdp-background-color);
        border: var(--rdp-outline);
        border-radius: 6px;
    }

    .rdp-caption-label {
        font-weight: ${theme.typography.fontWeight.medium};
        font-size: 1.15em;
    }

    .rdp-dropdown_icon {
        margin: 0 0 0 5px;
    }

    .rdp-head {
        border: 0;
    }
    .rdp-head_row {
        padding: 0.5em;
        color: #8b9898;
        text-align: center;
        font-size: 0.875em;
    }
    .rdp-head_row,
    .rdp-row {
        height: 100%;
    }

    .rdp-head_cell {
        vertical-align: middle;
        text-align: center;
        height: 100%;
        height: var(--rdp-cell-size);
        padding: 0;
        font-weight: ${theme.typography.fontWeight.roman};
    }

    .rdp-tbody {
        border: 0;
    }

    .rdp-tfoot {
        margin: 0.5em;
    }

    .rdp-cell {
        width: var(--rdp-cell-size);
        height: 100%;
        height: var(--rdp-cell-size);
        padding: 0;
        text-align: center;
    }

    .rdp-weeknumber {
        font-size: 0.75em;
    }

    .rdp-weeknumber,
    .rdp-day {
        display: flex;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: var(--rdp-cell-size);
        max-width: var(--rdp-cell-size);
        height: var(--rdp-cell-size);
        margin: 0;
        border-radius: 50%;
    }

    .rdp-day:not(.rdp-day_selected):not(.rdp-day_disabled):not(.rdp-day_interactionDisabled):hover {
        background-color: rgba(31, 186, 89, 0.1);
    }

    .rdp-day_today:not(.rdp-day_outside):not(.rdp-day_selected) {
        color: ${theme.color.green1};
        font-weight: ${theme.typography.fontWeight.heavy};
    }

    .rdp-day_selected,
    .rdp-day_selected:focus-visible,
    .rdp-day_selected:hover {
        background-color: ${theme.color.green1};
        color: #f0f8ff;
    }

    .rdp-day_disabled.rdp-day_selected {
        opacity: 0.25;
    }

    .rdp-day_outside {
        opacity: 0.5;
    }

    .rdp-day_selected:focus-visible {
        /* Since the background is the same use again the outline */
        outline: var(--rdp-outline);
        outline-offset: 2px;
        z-index: 1;
    }

    .rdp:not([dir='rtl']) .rdp-day_range_start:not(.rdp-day_range_end) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .rdp:not([dir='rtl']) .rdp-day_range_end:not(.rdp-day_range_start) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .rdp[dir='rtl'] .rdp-day_range_start:not(.rdp-day_range_end) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .rdp[dir='rtl'] .rdp-day_range_end:not(.rdp-day_range_start) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .rdp-day_range_end.rdp-day_range_start {
        border-radius: 100%;
    }

    .rdp-day_range_middle {
        border-radius: 0;
    }
`;
